import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "graph-view" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "rate__info" }
const _hoisted_4 = { class: "graph" }
const _hoisted_5 = {
  key: 0,
  class: "value__item value__item--adjusted"
}
const _hoisted_6 = { class: "value__item__title" }
const _hoisted_7 = { class: "value__item__number" }
const _hoisted_8 = {
  key: 1,
  class: "value__item value__item--adjusted"
}
const _hoisted_9 = { class: "value__item__title" }
const _hoisted_10 = { class: "value__item__number" }
const _hoisted_11 = { class: "value__item value__item--result" }
const _hoisted_12 = { class: "value__item__title" }
const _hoisted_13 = { class: "value__item__number" }
const _hoisted_14 = { class: "value__item value__item--target" }
const _hoisted_15 = { class: "value__item__title" }
const _hoisted_16 = { class: "value__item__number" }

import { storeToRefs } from 'pinia';
import { useInventoryDashboardStore } from '../pages/useInventoryDashboardStore';
import { InventoryDashboardViewModel } from '../pages/inventoryDashboardViewModel';
import { i18n } from '@/i18n';
import { computed } from 'vue';
import { MetricTypes } from '../domains/entities/Dashboard';
import KpiChart from './chart/KpiChart.vue';
import { Kpi } from '../domains/entities/Kpi';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { UNASSIGNED_COLUMN } from '@/coreDomainsModule/constants';
import AmountChart from './chart/AmountChart.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'GraphViewSection',
  setup(__props) {

const t = i18n.t;

const store = useInventoryDashboardStore();
const { state } = storeToRefs(store);
const {} = store;
const vm = new InventoryDashboardViewModel();

const isDisplayKpiInfo = computed(() => state.value.information.metricType === MetricTypes.Turnover);

const kpiArchevementRate = computed(() =>
  state.value.information.dimensionValueGroups.map((dvg) => {
    const targetSummaryData = dvg.amounts.find((a) => DateService.compareYearMonths(a.yearMonth, state.value.displayYearMonth) === 0);
    const targetKpi = getKpiWithDisplayYearMonth(dvg.kpi);
    if (!targetSummaryData || !targetSummaryData.turnover || !targetKpi) return [0, 0];
    const normal = (targetKpi.kpiValue / targetSummaryData.turnover) * 100;
    if (!targetSummaryData.turnoverWithForecastAccuracy) return [normal, 0];
    return [normal, (targetKpi.kpiValue / targetSummaryData.turnoverWithForecastAccuracy) * 100];
  })
);

const rateColor = computed(() =>
  kpiArchevementRate.value.map((value) => [
    value[0] < 81 ? 'red' : value[0] < 100 ? 'yellow' : 'green',
    value[1] < 81 ? 'red' : value[1] < 100 ? 'yellow' : 'green',
  ])
);

const yMinMax = computed(() => {
  const allValues = state.value.information.dimensionValueGroups.flatMap((dvg) =>
    dvg.amounts.flatMap((a) => [a.turnover ?? 0, a.turnoverWithForecastAccuracy ?? 0])
  );
  return [Math.min(...allValues) * 1.2, Math.max(...allValues) * 1.2];
});

/**
 * 表示年月時点で有効なKPIを取得する。
 * @param kpis - KPI履歴配列
 */
const getKpiWithDisplayYearMonth = (kpis: Kpi[]) => {
  const currentDisplayDate = DateService.convertIYearMonthToLastDateIDate(state.value.displayYearMonth);
  return kpis.find(
    (k) =>
      (!k.valid_from || DateService.compareDates(k.valid_from, currentDisplayDate) !== 1) &&
      (!k.valid_to || DateService.compareDates(k.valid_to, currentDisplayDate) !== -1)
  );
};

const additionalTitles = computed(() => (isDisplayKpiInfo.value && state.value.forecastAccuracyPeriod ? ['', `(${t('調整後')})`] : ['']));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).information.dimensionValueGroups, (dimensionValueGroup, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "card__container"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(additionalTitles.value, (additionalTitle, titleIndex) => {
          return (_openBlock(), _createElementBlock("div", {
            key: titleIndex,
            class: _normalizeClass(["card", `${isDisplayKpiInfo.value ? 'card--with-kpi' : 'card--normal'} ${titleIndex === 1 ? 'card--adjusted' : ''}`])
          }, [
            _createElementVNode("div", _hoisted_2, [
              (
              dimensionValueGroup.dimensionValues.name ||
              dimensionValueGroup.dimensionValues.value ||
              dimensionValueGroup.dimensionValues.unit
            )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(dimensionValueGroup.dimensionValues.name) + " " + _toDisplayString(dimensionValueGroup.dimensionValues.value) + " " + _toDisplayString(dimensionValueGroup.dimensionValues.unit), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_unref(t)(_unref(UNASSIGNED_COLUMN))), 1)
                  ], 64))
            ]),
            (isDisplayKpiInfo.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["rate", `rate--${rateColor.value[index][titleIndex]}`])
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", null, _toDisplayString(_unref(t)(_unref(vm).metricTypesMapper[_unref(state).information.metricType])) + " " + _toDisplayString(_unref(t)(additionalTitle)), 1),
                    _createElementVNode("div", null, _toDisplayString(_unref(t)('KPI達成率')), 1)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["rate__value", `rate__value--${rateColor.value[index][titleIndex]}`])
                  }, _toDisplayString(kpiArchevementRate.value[index] ? kpiArchevementRate.value[index][titleIndex].toFixed() : '--') + "% ", 3)
                ], 2))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              (isDisplayKpiInfo.value)
                ? (_openBlock(), _createBlock(KpiChart, {
                    key: 0,
                    "summary-amounts": dimensionValueGroup.amounts,
                    "kpi-data": dimensionValueGroup.kpi,
                    "from-year-month": _unref(state).displayYearMonthPeriod[0],
                    "to-year-month": _unref(state).displayYearMonthPeriod[1],
                    "use-adjusted": titleIndex === 1,
                    "min-scale": yMinMax.value[0],
                    "max-scale": yMinMax.value[1]
                  }, null, 8, ["summary-amounts", "kpi-data", "from-year-month", "to-year-month", "use-adjusted", "min-scale", "max-scale"]))
                : (_openBlock(), _createBlock(AmountChart, {
                    key: 1,
                    label: _unref(t)(_unref(vm).metricTypesMapper[_unref(state).information.metricType]),
                    "metric-type": _unref(state).information.metricType,
                    amounts: dimensionValueGroup.amounts,
                    "from-year-month": _unref(state).displayYearMonthPeriod[0],
                    "to-year-month": _unref(state).displayYearMonthPeriod[1]
                  }, null, 8, ["label", "metric-type", "amounts", "from-year-month", "to-year-month"]))
            ]),
            (isDisplayKpiInfo.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["value", titleIndex === 1 ? 'value--adjusted' : 'value--normal'])
                }, [
                  (titleIndex === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('正答率')), 1),
                        _createElementVNode("div", _hoisted_7, _toDisplayString(dimensionValueGroup.amounts
                  .find((a) => _unref(DateService).compareYearMonths(a.yearMonth, _unref(state).displayYearMonth) === 0)
                  ?.averageForecastAccuracy?.toFixed(2) ?? '--'), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (titleIndex === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('調整後')), 1),
                        _createElementVNode("div", _hoisted_10, _toDisplayString(dimensionValueGroup.amounts
                  .find((a) => _unref(DateService).compareYearMonths(a.yearMonth, _unref(state).displayYearMonth) === 0)
                  ?.turnoverWithForecastAccuracy?.toFixed(2) ?? '--'), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('実績')), 1),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(dimensionValueGroup.amounts
                  .find((a) => _unref(DateService).compareYearMonths(a.yearMonth, _unref(state).displayYearMonth) === 0)
                  ?.turnover?.toFixed(2) ?? '--'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)('目標')), 1),
                    _createElementVNode("div", _hoisted_16, _toDisplayString(getKpiWithDisplayYearMonth(dimensionValueGroup.kpi)?.kpiValue.toFixed(2) ?? '--'), 1)
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ], 2))
        }), 128))
      ]))
    }), 128))
  ]))
}
}

})